import React from "react";
import ImgBanner from "../../images/bg-banner.jpg";
import ImgDoctor from "../../images/banner-doctor.svg";
import Button from "../components/Button.js";
import InputText from "../components/InputText";
import InputSelect from "../components/InputSelect";
import DataSpescialities from '../../data/Spescialities.js'
import DataDoctors from '../../data/Doctors.js'
import DataBlogs from '../../data/Blogs.js'
import DataFeatures from '../../data/Features.js'
import DataGender from '../../data/Gender.js'
import DataDepartments from '../../data/Departments.js'
import Slider from "react-slick";
import CardDoctor from "../components/CardDoctor";
import CardBlog from "../components/CardBlog";
import ImgPhone from "../../images/img-phone.svg";

const Home = () => {
  
  const searchIc = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-4 h-4"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
      />
    </svg>
  );

  const spescialitiesSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
  };

  const doctorSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
  };

  const featureSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
  };

  return (
    <>
      <section
        className="bg-[#2D636BCF] bg-blend-darken text-white mx-auto px-4"
        style={{ backgroundImage: `url(${ImgBanner})` }}
      >
        <div className="container max-w-5xl mx-auto">
          <div className="flex justify-around gap-5">
            <div className="flex items-end">
              <img src={ImgDoctor} alt="Doctor" width={450} className="mt-20" />
            </div>

            <div className="flex flex-col justify-center">
              <p className="font-bold text-4xl leading-snug mb-10 ">
                Search Doctor, Make an Appointment
              </p>
              <div>
                <div className="grid grid-cols-3 gap-3 mb-5">
                  <InputText placeholder={"Location"} />
                  <InputSelect options={DataGender} placeholder={"Gender"} />
                  <InputSelect options={DataDepartments} placeholder={"Department"} />
                </div>
                <Button
                  title="Search"
                  icon={searchIc}
                  bgColor="bg-secondary"
                  ringColor="ring-secondary"
                  borderColor="border-secondary"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10">
        <div className="pb-10">
          <div className="flex flex-col items-center text-center mb-8">
            <h3 className="inline-block font-semibold text-3xl text-center border-b-4 border-primary pb-3 px-10">
              Clinic and Specialities
            </h3>

            <p className="mt-8 max-w-xl">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </div>

          <div className="max-w-5xl mx-auto">
            <Slider {...spescialitiesSettings}>
              {DataSpescialities &&
                DataSpescialities.map((spesical, index) => (
                  <div key={index}>
                    <div className="bg-white rounded-full shadow-gray-300 shadow-md border w-24 h-24 overflow-hidden inline-flex justify-center">
                      <img src={spesical.icon} alt={spesical.name} width={50} />
                    </div>
                    <p className="mt-2 hover:text-primary">{spesical.name}</p>
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </section>

      <section className="py-10 bg-[#F8F9FA] container mx-auto px-4">
        <div className="flex flex-col items-center text-center gap-8">
          <h3 className="inline-block font-semibold text-3xl text-center border-b-4 border-primary pb-3 px-10">
            Browse by Specialities
          </h3>

          <p className="max-w-xl">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>

          <div className="max-w-6xl mx-auto grid grid-cols-4 gap-5 w-full">
            {DataSpescialities &&
              DataSpescialities.map((spesical, index) => (
                <div
                  key={index}
                  className=" bg-white rounded-md shadow-md overflow-hidden pb-1"
                >
                  <div className="bg-[#CCEFFC] px-4 py-3 rounded-b-md inline-block">
                    <img src={spesical.icon} alt={spesical.name} width={50} />
                  </div>
                  <p className="font-bold mt-2">{spesical.name}</p>
                  <small className="mt-2">{spesical.jmlDoctor} Doctors</small>
                </div>
              ))}
          </div>
        </div>
      </section>

      <section className="py-10 container mx-auto px-4">
        <div className="pb-10">
          <div className="flex flex-col items-center text-center mb-8">
            <h3 className="inline-block font-semibold text-3xl text-center border-b-4 border-primary pb-3 px-10">
              Book Our Best Doctor
            </h3>

            <p className="mt-8 max-w-xl">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </div>

          <div className="max-w-6xl mx-auto">
            <Slider {...doctorSettings}>
              {DataDoctors &&
                DataDoctors.map((doctor, index) => (
                  <CardDoctor key={index} data={doctor} />
                ))}
            </Slider>
          </div>
        </div>
      </section>

      <section className="py-10 bg-[#F8F9FA] container mx-auto px-4">
        <div className="flex justify-center gap-8 items-end">
          <div>
            <img src={ImgPhone} alt="Phone" className="" width={330} />
          </div>
          <div>
            <h3 className="inline-block font-semibold text-3xl text-start border-b-4 border-primary pb-3 pr-10">
              Availabe Features in Our Clinic
            </h3>

            <p className="mt-8 max-w-xl mb-20">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            <div className="max-w-xl">
              <Slider {...featureSettings}>
                {DataFeatures &&
                  DataFeatures.map((feature, index) => (
                    <div key={index}>
                      <img
                        src={feature.image}
                        alt={feature.name}
                        className="rounded-full shadow-gray-300 shadow-md border w-28 mx-auto"
                      />
                      <p className="mt-2 text-center">{feature.name}</p>
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 container mx-auto px-4">
        <div className="pb-10">
          <div className="flex flex-col items-center text-center mb-8">
            <h3 className="inline-block font-semibold text-3xl text-center border-b-4 border-primary pb-3 px-10">
              Blogs and News
            </h3>

            <p className="mt-8 max-w-xl">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </div>

          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-4 gap-3">
              {DataBlogs &&
                DataBlogs.map((blog, index) => (
                  <CardBlog key={index} data={blog} />
                ))}
            </div>
          </div>

          <div className="mt-8 text-center">
            <Button
              title="View All"
              bgColor="bg-secondary"
              ringColor="ring-secondary"
              borderColor="border-secondary"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
